/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import classNames from 'classnames'
import icons from '@betterplace/react-icons'
import styles from './Icon.module.css'
import { IconProps } from './types'

const brandIconColors: Partial<Record<keyof typeof icons, string>> = {
  facebook: '#1877F2',
  instagram: '#E1306C',
  linkedin: '#0077B5',
}

function Icon({
  size = '300',
  color,
  title,
  name,
  className: userClassName,
  style,
  minTargetSizeInRem = 0,
  ...props
}: IconProps) {
  const ChosenIcon = icons[name] ?? null
  if (!ChosenIcon) {
    throw new Error(`Icon ${name} does not exist`)
  }

  const colorVar = (color && `var(--betterplace-color-${color})`) || brandIconColors[name]
  const colorProps = { fill: colorVar }

  return (
    <ChosenIcon
      {...props}
      aria-label={title}
      aria-hidden={!title}
      className={classNames(styles.icon, userClassName)}
      style={
        {
          width: `var(--betterplace-sizing-${size})`,
          height: `var(--betterplace-sizing-${size})`,
          padding: `calc((${minTargetSizeInRem}rem - var(--betterplace-sizing-${size})) / 2)`,
          boxSizing: 'content-box',
          ...colorProps,
          ...style,
        } as React.CSSProperties
      }
    />
  )
}

export default Icon
